module.exports = function () {

    let module = {};

    module.environment = process.env.NODE_ENV;
    module.isLive = (module.environment == 'production') ? true : false;
    module.isStaging = (module.environment == 'staging') ? true : false;
    module.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;


    module.log = function (message) {
        if (!module.isStaging && !module.isLive)
            return console.log(message);
    };

    // Only include Bootstrap modules required
    module.initBootstrap = function () {
        require('bootstrap/js/dist/index');
        require('bootstrap/js/dist/alert');
        require('bootstrap/js/dist/button'); // required for auto complete library
        //require('bootstrap/js/dist/carousel');
        require('bootstrap/js/dist/collapse');
        require('bootstrap/js/dist/dropdown');
        require('bootstrap/js/dist/modal');
        // require('bootstrap/js/dist/popover');
        // require('bootstrap/js/dist/scrollspy');
        require('bootstrap/js/dist/tab');
        // require('bootstrap/js/dist/util');
    };

    module.initBootstrapToggle = function () {
        require('bootstrap4-toggle');
    };

    module.initDatepicker = function () {
        const AirDatepicker = require("air-datepicker/air-datepicker");

        const localeEn = require('air-datepicker/locale/en');

        let today = new Date;
        let minDate = (new Date).setFullYear(today.getFullYear() - 100);
        let maxDate = (new Date).setFullYear(today.getFullYear() - 18);

        new AirDatepicker('.datepicker', {
            locale: localeEn.default,
            timepicker: false,
            minHours: 8,
            maxHours: 17,
            minutesStep: 15,
            timeFormat: 'HH:mm',
            minDate: minDate,
            maxDate: maxDate,
            dateFormat: 'dd MMMM yyyy'
        });

    };

    module.enquiryDatepickers = function () {

        const AirDatepicker = require("air-datepicker/air-datepicker");

        const localeEn = require('air-datepicker/locale/en');

        let minDate = new Date;
        let maxDate = (new Date).setFullYear(minDate.getFullYear() + 1);
        let collectionDatepicker;
        let returnDatepicker;

        collectionDatepicker = new AirDatepicker('#collection_date', {
            locale: localeEn.default,
            timepicker: false,
            minHours: 8,
            maxHours: 17,
            minutesStep: 15,
            timeFormat: 'HH:mm',
            minDate: minDate,
            maxDate: maxDate,
            dateFormat: 'dd MMMM yyyy',
            onSelect({date}) {
                returnDatepicker.update({
                    minDate: date
                })
            }
        });

        returnDatepicker = new AirDatepicker('#start_date', {
            locale: localeEn.default,
            timepicker: false,
            minHours: 8,
            maxHours: 17,
            minutesStep: 15,
            timeFormat: 'HH:mm',
            minDate: minDate,
            maxDate: maxDate,
            dateFormat: 'dd MMMM yyyy'
        });

        returnDatepicker = new AirDatepicker('#pick_up_date', {
            locale: localeEn.default,
            timepicker: true,
            minHours: 8,
            maxHours: 17,
            minutesStep: 15,
            timeFormat: 'HH:mm',
            minDate: minDate,
            maxDate: maxDate,
            dateFormat: 'dd MMMM yyyy'
        });

        returnDatepicker = new AirDatepicker('#drop_off_date', {
            locale: localeEn.default,
            timepicker: true,
            minHours: 8,
            maxHours: 17,
            minutesStep: 15,
            timeFormat: 'HH:mm',
            minDate: minDate,
            maxDate: maxDate,
            dateFormat: 'dd MMMM yyyy'
        });

    }


    module.initLazyLoad = function () {
        const lasysizes = require('lazysizes/lazysizes');
        lazySizes.cfg.lazyClass = 'lazy';
    };

    module.initRrssb = function () {
        require('rrssb');
    };

    module.initPopups = function () {
        if ($('#popupModal').length) {
            let id = $('#popupModal').data('id');
            let popupShown = localStorage.getItem('popup-' + id + '-shown');
            let expirationDate = localStorage.getItem('popup-' + id + '-expiration');

            // Check if the popup has been shown and if the expiration date has passed
            if (!popupShown || Date.now() > parseInt(expirationDate)) {
                let delay = parseInt($('#popupModal').data('delay') + '000');
                let next_display_time = parseInt($('#popupModal').data('next-display-time'));
                const expirationTime = Date.now() + (next_display_time ? next_display_time : 7) * 24 * 60 * 60 * 1000; // Current time + 7 days in milliseconds

                setTimeout(function () {
                    $('#popupModal').modal('show');
                    localStorage.setItem('popup-' + id + '-shown', 'true');
                    localStorage.setItem('popup-' + id + '-expiration', expirationTime.toString());
                }, delay ? delay : 2000);
            }
        }
    };

    module.keepTokenAlive = function () {

        // To override the default mins, add a <body> data tag value for 'token_minutes'
        let keepAlive = $('body').data('token-minutes');

        setInterval(keepTokenAlive, 1000 * 60 * (keepAlive ? keepAlive : 3)); // every 3 or x mins

        function keepTokenAlive() {
            $.ajax({
                url: '/keep-token-alive', //https://stackoverflow.com/q/31449434/470749
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).then(function (result) {
                console.log(new Date() + ' ' + result + ' ' + $('meta[name="csrf-token"]').attr('content'));
            });
        }
    }

    module.initTooltips = function () {
        require('bootstrap/js/dist/tooltip');

        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover focus',
            placement: 'bottom',
            container: 'body'
        });
    };

    module.initStickyEl = function () {

        // Get sticky el's
        let el = $('.is-sticky');

        sessionStorage.setItem('height', $('header').height());

        // When the user scrolls the page, execute myFunction
        window.onscroll = function () {
            module.addStickyClass();
        };

        module.addStickyClass();
    };

    module.addStickyClass = function () {

        let body = $('body');

        let height = sessionStorage.getItem('height') ? sessionStorage.getItem('height') : $('header').height();

        if (window.pageYOffset >= (height / 2) && window.pageYOffset < height) {
            body.addClass("before-stuck").removeClass("stuck").css('padding-top', '0');
        } else if (window.pageYOffset == 0) {
            body.removeClass("stuck").removeClass("before-stuck").css('padding-top', '0');
        } else if (window.pageYOffset > height) {
            body.addClass("stuck").removeClass("before-stuck").css('padding-top', height + 'px');

        }

    };


    module.navDropdownHover = function () {

        const $dropdown = $(".dropdown");
        const $dropdownToggle = $(".dropdown-toggle");
        const $dropdownMenu = $(".dropdown-menu");
        const showClass = "show";

        $(window).on("load resize", function () {
            if (this.matchMedia("(min-width: 768px)").matches) {
                $dropdown.hover(
                    function () {
                        const $this = $(this);
                        $this.addClass(showClass);
                        $this.find($dropdownToggle).attr("aria-expanded", "true");
                        $this.find($dropdownMenu).addClass(showClass);
                    },
                    function () {
                        const $this = $(this);
                        $this.removeClass(showClass);
                        $this.find($dropdownToggle).attr("aria-expanded", "false");
                        $this.find($dropdownMenu).removeClass(showClass);
                    }
                );
            } else {
                $dropdown.off("mouseenter mouseleave");
            }
        });
    };


    module.announcementBarDismiss = function () {
        if ($('#announcement-dismiss').length) {
            $('#announcement-dismiss').click(function () {
                $.get("/announcement-dismiss", function () {
                    console.log("Announcement bar dismissed");
                    $('#announcement-dismiss').fadeOut(300);
                })
            });
        }
    };

    module.initLightbox = function () {
        require('ekko-lightbox');
        $(document).on('click', '[data-toggle="lightbox"]', function (event) {
            event.preventDefault();
            $(this).ekkoLightbox({
                alwaysShowClose: false,
                leftArrow: '<i class="fa fa-chevron-left left"></i>',
                rightArrow: '<i class="fa fa-chevron-right right"></i>'
            });
        });
    };

    module.initMobileMenu = function () {
        require('../plugins/jquery-simple-mobile-menu');
        $(".mobile_menu").simpleMobileMenu();
        $('#sm_menu_ham').addClass('icon').prependTo('.mobile-icons');
    };

    module.initSlickCarousel = function () {
        require('@accessible360/accessible-slick');

        require('slick-carousel');



        if ($('.slider-for').length) {

            $('.slider-for').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.slider-nav'
            });
            $('.slider-nav').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: '.slider-for',
                vertical: false,
                arrows: false,
                dots: false,
                focusOnSelect: true
            });

            $('a[data-slide]').click(function (e) {
                e.preventDefault();
                var slideno = $(this).data('slide');
                $('.slider-nav').slick('slickGoTo', slideno - 1);
            });

        }

        /*if ($('.slider-vertical').length) {

            $('.slider-vertical').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.slider-nav-vertical'
            });
            $('.slider-nav-vertical').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: '.slider-vertical',
                vertical: true,
                arrows: false,
                dots: false,
                focusOnSelect: true
            });

            $('a[data-slide]').click(function (e) {
                e.preventDefault();
                var slideno = $(this).data('slide');
                $('.slider-nav').slick('slickGoTo', slideno - 1);
            });

        }*/

        $('.slick.simple-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            dots: false,
        });


        $('.slick.variable').slick({
            infinite: true,
            speed: 1000,
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
            arrows: true,
            autoplay: true,
            cssEase: 'ease-in-out',
            autoplaySpeed: 3000,

        });

        $('.slick-carousel.vehicles').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            //variableWidth: false,
            //adaptiveHeight: false,
            arrows: true,
            dots: false,
            prevArrow: $('.vehicle-prev'),
            nextArrow: $('.vehicle-next'),

            responsive: [

                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 3.5,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2.4,
                        centerPadding: '100px'
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1.5,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.2,
                        centerPadding: '10px'
                    }
                }
            ],

        });


        if ($('.shortcode-slider').length) {

            $('.slick.shortcode-slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                fade: true,
                arrows: false,
                dots: true,
                cssEase: 'linear',
            });
        }

        $('.slick.team').slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,


            responsive: [

                {
                    breakpoint: 968,
                    settings: {
                        slidesToShow: 2,
                        centerMode: true,
                        centerPadding: '150px',
                    }
                },

                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ]
        });

        $('.slick.variable').slick({
            infinite: true,
            speed: 1000,
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
            arrows: true,
            autoplay: true,
            cssEase: 'ease-in-out',
            autoplaySpeed: 3000,

        });


        $('.slick.main-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: false,
            dots: true,
        });


        if ($('.single .slick').length) {
            $('.single .slick').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                arrows: false,
                dots: true,
            });
        }

        $('.slick.testimonials-slides').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            arrows: false,
            cssEase: 'linear',
            dots: false,

            responsive: [

                {
                    breakpoint: 992, // sm
                    settings: {
                        slidesToShow: 1
                    }
                },

            ]


        });

        $('.slick.lead-articles').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '350px',
            draggable: true,
            arrows: false,
            dots: true,

            responsive: [
                {
                    breakpoint: 1500,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '150px',
                        centerMode: true,
                    }
                },

                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false,
                    }
                },

                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                    }
                },
            ]

        });

        if ($('.vehicle-carousel').length) {
            $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                if ($(this).find('.vehicle-carousel'))
                    $('.slick.vehicle-carousel').slick('refresh');
            })

            $('.slick.vehicle-carousel').slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: true,
                arrows: false,

                responsive: [
                    {
                        breakpoint: 1360, // xl
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1140, // sm
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 960, // sm
                        settings: {
                            slidesToShow: 1
                        }
                    },

                ]

            });

        }

        if ($('.slick.vehicle-tiles').length) {
            $('.slick.vehicle-tiles').slick({
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplay: false,
                arrows: false,
                speed: 4000,
                autoplaySpeed: 0,
                cssEase: 'linear',

                responsive: [
                    {
                        breakpoint: 1500,
                        settings: {
                            slidesToShow: 6
                        }
                    },
                    {
                        breakpoint: 1300,
                        settings: {
                            slidesToShow: 5
                        }
                    },
                    {
                        breakpoint: 968,
                        settings: {
                            slidesToShow: 3
                        }
                    },

                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });
        }

        if ($('.slick.logos').length) {
            $('.slick.logos').slick({
                infinite: true,
                slidesToShow: 7,
                slidesToScroll: 1,
                autoplay: true,
                arrows: false,
                speed: 4000,
                autoplaySpeed: 0,
                cssEase: 'linear',

                responsive: [
                    {
                        breakpoint: 1500,
                        settings: {
                            slidesToShow: 6
                        }
                    },
                    {
                        breakpoint: 1300,
                        settings: {
                            slidesToShow: 5
                        }
                    },
                    {
                        breakpoint: 968,
                        settings: {
                            slidesToShow: 3
                        }
                    },

                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });
        }

        if ($('.slick.reviews').length) {

            $('.slick.reviews').slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,

                responsive: [
                    {
                        breakpoint: 968,
                        settings: {
                            slidesToShow: 1
                        }
                    },

                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });
        }

        $('.slick.carousel').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            draggable: false,
            responsive: [
                {
                    breakpoint: 968,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ]
        });


    };



    module.scrollToAnchor = function () {
        $('a[href^=\\#scroll-]').on('click', function (e) {
            e.preventDefault();

            let collapseId = $(this).attr('href').replace('scroll-', '');

            console.log(collapseId);

            module.scrollToElement(collapseId);
        });
    };


    module.detectUrlScrollHash = function () {
        if (window.location.hash.indexOf('scroll-') == 1) {

            let el = window.location.hash.replace('scroll-', '');

            console.log('Attempting automatic scroll to ' + el);

            this.scrollToElement(el);
        }
    };

    module.scrollToElement = function (element) {
        console.log('Attempt to scroll to el ' + element);
        $('html,body').animate({scrollTop: $(element).offset().top - 100}, 'slow', function () {
            if ($(element).length && $(element).next().hasClass('collapse')) {
                $(element).next().collapse('show');
            }
        });
    };


    module.scrollToAccordionItem = function () {

        $('.accordion').on('shown.bs.collapse', function (event) {
            let getHeaderEl = $('#' + event.target.id).prev('.card-header').attr('id');

            if (getHeaderEl)
                module.scrollToElement('#' + getHeaderEl);
        });

    };

    module.initWowJs = function () {
        const {WOW} = require('wowjs');
        new WOW({
            mobile: false,
        }).init();
    };


    module.convertCryptedEmails = function () {

        $('.cryptedmail').each(function () {

            let
                el = $(this).find('span'),
                e = el.data('name') + '@' + el.data('domain') + '.' + el.data('tld');

            $(this).attr('href', 'mailto:' + e).removeClass('cryptedmail').find('span');

            if ((typeof el.data('show-value') == 'undefined') || el.data('show-value'))
                el.html(el.data('value') ? el.data('value') : e);
        });
    };

    module.showScrollIcon = function () {
        $(document).ready(function() {
            function checkScrollbar() {
                // Check if the tab-items container is scrollable horizontally
                var isScrollable = $('.tab-items').prop('scrollWidth') > $('.tab-items').outerWidth();

                // Show or hide the element based on scrollability
                if (isScrollable) {
                    $('.show-if-scroll').show();
                } else {
                    $('.show-if-scroll').hide();
                }
            }

            // Check scrollbar on page load
            checkScrollbar();

            // Optionally, check scrollbar on window resize
            $(window).resize(function() {
                checkScrollbar();
            });
        });
    };

    module.initSpotlightJs = function () {
        require('spotlight.js');
    };

    module.initTingleModalJs = function () {

        const Tingle = require('tingle.js');

        var modal = new Tingle.modal({
            stickyFooter: false,
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            cssClass: ['custom-class-1', 'custom-class-2'],
        });

        $('.md-trigger').click(function (event) {
            let id = $(this).data('id');
            modal.setContent($('#' + id).html());
            modal.open();
        });
    };

    return module;

};
